module.exports = __webpack_public_path__ + "b-corp-d-uk-vrF.png";